"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMoistureLoadFileMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.updateMoistureLoadFileMutation = (0, graphql_tag_1.default) `
  mutation UpdateMoistureLoadFile($input: UpdateMoistureLoadFileInputType!) {
    updateMoistureLoadFile(input: $input) {
      id
      errorMessage
    }
  }
`;
//# sourceMappingURL=update-moisture-load-file.js.map